/* eslint-disable */ 
import React, { useEffect, useState } from "react";
import api from "../api/api"
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { InvoiceLogo1 } from "../_components/Imagepath";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailrgx } from "../assets/constant";
import PasswordResetNotifications from "./PasswordResetNotifications";
import { useTranslation } from "react-i18next";
import Lang from "../common/Lang";
const PasswordReset = (props) => {

  const { t } = useTranslation();
  const history = useHistory();
  const [LoadingSubmit,setLoadingSubmit] = useState(false)
  const [SuccessSubmit,setSuccessSubmit] = useState(null)

  const schema = yup.object({
    password1: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required")
      .trim(),
    password2: yup
      .string()
      .oneOf([yup.ref("password1")], "Passwords must match")
      .required("Confirm password is required"),
  });
  
  const inputValues = {
    password1: "",
    password2: "",
  };
  
  const {
    reset,
    handleSubmit,
    control,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: inputValues,
  });

  useEffect(() => {
    reset(inputValues);
  }, [reset]);

  useEffect(() =>{
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const token = urlParams.get('token');

    const data = {"id": id, "token": token};

    const checkLink = async () => {
      try {
        const response = await axios.post(process.env.REACT_APP_BASE_URL+"/auth/password-reset-token-check/", data);
        
        // Handle the HTML response (failure message)
        if (!response.data.valid) {
          history.push('error-404')
        }

        
      } catch (error) {
        console.error('Error password reset:', error);
        history.push('error-404')
      }
    };

    checkLink();
  }, [])

  const onSubmit = async(data) => {
    clearErrors();
    setSuccessSubmit(null);
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const token = urlParams.get('token');

    let typeurl = "auth/password-reset/"

    const payload = {
      id,
      token,
      password1: data.password1,
      password2: data.password2,
    };

    if (LoadingSubmit) return;
    setLoadingSubmit(true);
    
    try {
      const response = await api.post(typeurl, payload); 

      console.log("Response Code:", response.status);

      reset();
      setSuccessSubmit(response.data.success)
      console.log(SuccessSubmit);
    } catch (error) {
      console.log(error);
      
      let  errorMessage = ""
      
      // Extract response code if available
      const responseCode = error.response ? error.response.status : "Unknown";
      console.log("Response Code:", responseCode);
      console.log(error.response);
      
      
      if (error?.response?.data) {   
        if (error.response.data.detail == "Same password") {
          errorMessage = "The new password cannot be the same as your current password.";
        } else {
          errorMessage = error.response.data.detail;
        }
      }
          
      // If no specific error was found, provide a default message
      if (!errorMessage) {
        errorMessage = "An unknown error occurred.";
      }
      
      // Set the error message in React Hook Form
      setError("root", { type: "server", message: errorMessage });
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <>
    { !SuccessSubmit ? (
      <div className="main-wrapper login-body">
      <div className="login-wrapper">
        <div className="container">
          <img
            className="img-fluid logo-dark mb-2"
            src={InvoiceLogo1}
            alt="Logo"
          />

          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>Password Reset</h1>
                <p className="account-subtitle">
                  Enter your new password
                </p>

                {/* Form */}
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Controller
                    name="password1"
                    control={control}
                    render={({ field }) => (
                      <div className="input-block mb-3">
                        <label className="form-control-label">{t("Password")}</label>
                        <input
                          {...field}
                          className="form-control"
                          type="password"
                          placeholder=""
                          onChange={(e) => {
                            field.onChange(e);
                            clearErrors("root");    // clear root error when typing
                          }}
                        />
                        {errors.password1 && (
                          <small className="text-danger">{errors.password1.message}</small>
                        )}
                      </div>
                    )}
                  />
                  <Controller
                    name="password2"
                    control={control}
                    render={({ field }) => (
                      <div className="input-block mb-3">
                        <label className="form-control-label">{t("Confirm Password")}</label>
                        <input
                          {...field}
                          className="form-control"
                          type="password"
                          placeholder=""
                          onChange={(e) => {
                            field.onChange(e);      // keep RHF in sync
                            clearErrors("root");    // clear root error when typing
                          }}
                        />
                        {errors.password2 && (
                          <small className="text-danger">{errors.password2.message}</small>
                        )}
                      </div>
                    )}
                  />
                  <small style={{ color: "red" }}>
                    {errors.root && <p>{errors.root.message}</p>}
                  </small>
                  <div className="input-block mb-0">
                    <button
                      className="btn btn-lg btn-block w-100 btn-primary w-100"
                      type="submit"
                    >
                      {t("Reset Password")}
                    </button>
                  </div>
                </form>
                {/* /Form */}

                <div className="text-center dont-have">
                  {t("Remember your password?")} <Link to="/login">{t("Login")}</Link>
                </div>
              </div>
            </div>
          </div>
           <div className="lang-menu">
                <ul className="nav nav-tabs user-menu">
                  <Lang />
                </ul>

              </div>
        </div>
      </div>
    </div>
    ) : (
      <PasswordResetNotifications />
    )
    }
    </>
  );
};
export default PasswordReset;
